import * as service from './service'
export default {
  namespace: 'recommendUserRecommendDetail',
  state: {
    demoData: {}
  },
  effects: {
    * getUserAwardRules ({ payload }, { call, put }) {
      const res = yield call(service.getUserAwardRules, payload)
      return res.data
    },
    * getUserAwardPhase ({ payload }, { call, put }) {
      const res = yield call(service.getUserAwardPhase, payload)
      return res.data
    },
    * findAwardPage ({ payload }, { call, put }) {
      const res = yield call(service.findAwardPage, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
